import { createFileRoute } from "@tanstack/react-router";
import { LegalPageLayout } from "@/components/legal-page-layout";
import { COMPANY, formatAddress } from "@/lib/company-info";

export const Route = createFileRoute("/yasal/mesafeli-satis-sozlesmesi")({
  head: () => ({
    meta: [
      { title: "Mesafeli Satış Sözleşmesi — JUËN" },
      { name: "description", content: "JUËN üzerinden yapılan satışlara ilişkin mesafeli satış sözleşmesi koşulları." },
      { property: "og:title", content: "Mesafeli Satış Sözleşmesi — JUËN" },
      { property: "og:description", content: "JUËN üzerinden yapılan satışlara ilişkin mesafeli satış sözleşmesi koşulları." },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <LegalPageLayout title="Mesafeli Satış Sözleşmesi" lastUpdated="01.05.2026">
      <h2>1. Taraflar</h2>
      <p>
        İşbu Mesafeli Satış Sözleşmesi ("Sözleşme"), aşağıda bilgileri yer alan SATICI ile{" "}
        {COMPANY.website} ("Site") üzerinden ürün/hizmet satın alan ALICI arasında, 6502 sayılı
        Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümlerine
        uygun olarak elektronik ortamda kurulmuştur.
      </p>

      <h3>SATICI</h3>
      <ul>
        <li><strong>Unvan:</strong> {COMPANY.legalName}</li>
        <li><strong>Adres:</strong> {formatAddress()}</li>
        <li><strong>Telefon:</strong> {COMPANY.phone}</li>
        
      </ul>

      <h3>ALICI</h3>
      <p>
        Site üzerinden üyelik oluşturarak ve sipariş vererek bu sözleşmeyi kabul eden gerçek/tüzel
        kişi. ALICI'nın bilgileri sipariş anında sistemde kayıtlıdır.
      </p>

      <h2>2. Sözleşmenin Konusu</h2>
      <p>
        İşbu sözleşmenin konusu, ALICI'nın Site üzerinden elektronik ortamda sipariş ettiği,
        aşağıda nitelikleri ve satış fiyatı belirtilen ürün/hizmetlerin (etkinlik bileti, üyelik,
        içecek kuponu vb.) satışı ve teslimi ile ilgili olarak tarafların hak ve yükümlülüklerinin
        belirlenmesidir.
      </p>

      <h2>3. Ürün/Hizmet Bilgileri</h2>
      <p>
        Satışa konu ürün/hizmetlerin temel nitelikleri, KDV dahil satış fiyatı, ödeme şekli ve
        teslimat bilgileri Site'deki ilgili ürün sayfasında ve sipariş özetinde belirtilmiştir.
        Listelenen fiyatlar satış fiyatıdır; ilan edilen fiyatlar yeni fiyatlar ilan edilinceye
        kadar geçerlidir.
      </p>

      <h2>4. Genel Hükümler</h2>
      <ul>
        <li>ALICI, Site'de yer alan ürün/hizmetin temel nitelikleri, satış fiyatı, ödeme şekli ve teslimata ilişkin tüm ön bilgileri okuyup bilgi sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini kabul eder.</li>
        <li>Sözleşme konusu hizmet (etkinlik bileti, üyelik, içecek kuponu) elektronik ortamda anında teslim edilir; ALICI sipariş onayından sonra hesabında bilet/kupon olarak görüntüleyebilir.</li>
        <li>SATICI, sipariş konusu ürün veya hizmetin yerine getirilmesinin imkânsızlaşması halinde durumu ALICI'ya bildirir ve ödenen tutarı 14 gün içinde iade eder.</li>
      </ul>

      <h2>5. Cayma Hakkı</h2>
      <p>
        Mesafeli Sözleşmeler Yönetmeliği'nin 15. maddesi uyarınca, <strong>belirli bir tarihte
        veya dönemde yapılması gereken eğlence sektörüne ilişkin hizmetlere</strong> (etkinlik
        biletleri, konser, gece kulübü etkinlikleri vb.) yönelik sözleşmelerde ALICI'nın cayma
        hakkı bulunmamaktadır. Bu nedenle satın alınan etkinlik biletleri, üyelikler ve içecek
        kuponları için cayma hakkı kullanılamaz. İade koşulları için "İade ve İptal Politikası"
        sayfasını inceleyiniz.
      </p>

      <h2>6. Uyuşmazlıkların Çözümü</h2>
      <p>
        İşbu Sözleşme'den doğabilecek uyuşmazlıklarda, Gümrük ve Ticaret Bakanlığınca her yıl
        belirlenen parasal sınırlar dahilinde ALICI'nın yerleşim yerindeki Tüketici Hakem
        Heyetleri ve Tüketici Mahkemeleri yetkilidir.
      </p>

      <h2>7. Yürürlük</h2>
      <p>
        ALICI, Site üzerinden verdiği siparişe ait ödemeyi gerçekleştirmekle işbu sözleşmenin
        tüm koşullarını kabul etmiş sayılır. Sözleşme, sipariş onayı ile yürürlüğe girer.
      </p>
    </LegalPageLayout>
  );
}
